import { Button, Form, Input, InputNumber, message, Select } from "antd";
import React, { useState } from "react";

import { FetchError } from "../../../exceptions/AlgoSupervisionExceptions";
import { LinkedInBudgetLevel } from "../../../models/linkedin-manager/strategy/LinkedInBudgetLevel";
import { LinkedInBudgetStrategy } from "../../../models/linkedin-manager/strategy/LinkedInBudgetStrategy";
import { linkedinStrategyManagementService } from "../../../services/linkedin/LinkedInStrategyManagementService";
import Loader from "../../general/loader/Loader";

const { Option } = Select;

type FormState = {
    budgetLevel: LinkedInBudgetLevel;
    percentOfStrategies: string;
};

type Props = {
    companyId: string | number;
    onFormSubmitSuccesfully: (
        newlyCreatedStrategy: LinkedInBudgetStrategy
    ) => void;
};

const LinkedInStrategyForm = (props: Props) => {
    const { companyId, onFormSubmitSuccesfully } = props;

    const [form] = Form.useForm();
    const [budgetLevel, setBudgetLevel] =
        useState<LinkedInBudgetLevel>();
    const [loading, setLoading] = useState<boolean>(false);

    const onFinish = async (formState: FormState) => {
        setLoading(true);
        try {
            const newlyCreatedStrategy =
                await linkedinStrategyManagementService.CreateStrategy(
                    companyId,
                    {
                        budgetLevel: formState.budgetLevel,
                        percentOfStrategies: Number(
                            formState.percentOfStrategies
                        )
                    }
                );

            onFormSubmitSuccesfully(newlyCreatedStrategy);

            message.success("Created new strategy successfully");
        } catch (error) {
            if (error instanceof FetchError) {
                message.error(error.apiError.errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            // {...formItemLayout}
            layout={"inline"}
            form={form}
            onFinish={onFinish}
            // initialValues={{ layout: formLayout }}
        >
            <Form.Item
                rules={[{ required: true }]}
                label="Budget Level"
                name="budgetLevel">
                <Select
                    style={{ width: 170 }}
                    onChange={(val: LinkedInBudgetLevel) => {
                        setBudgetLevel(val);
                    }}>
                    <Option value={LinkedInBudgetLevel.LOW}>
                        Low
                    </Option>
                    <Option value={LinkedInBudgetLevel.MEDIUM}>
                        Medium
                    </Option>
                    <Option
                        value={LinkedInBudgetLevel.HIGH}>
                        High
                    </Option>
                    <Option
                        value={LinkedInBudgetLevel.VERY_HIGH}>
                        Very High
                    </Option>
                </Select>
            </Form.Item>

            <Form.Item
                rules={[{ required: true }]}
                label="Percent of strategies"
                name="percentOfStrategies">
                <InputNumber type="number" placeholder="5" min={5} step={5}  />
            </Form.Item>

            {loading ? (
                <Loader position="normal" />
            ) : (
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            )}
        </Form>
    );
};

export default LinkedInStrategyForm;
